<template>
    <div class="top-tips">
        <div v-if="appConfig.appId == '1018'" class="tips-1018">
            <p>{{ $t('ruTips1') }}</p>
            <p>{{ $t('ruTips2') }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'top-tips',
    props: {
        appConfig: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
        };
    },
    methods: {
    },
};
</script>

<style lang="scss" scoped>
.top-tips {
    .tips-1018 {
        color: #000;
        text-align: left;
        width: 1200px;
        margin: 0 auto;
        margin-bottom: 10px;

        p {
            margin: 0;
            padding: 0;
        }
    }
}
</style>